import request from '../axios'
import { baseUrl } from '@/config/env'

interface Params {
	[key: string]: any
}
// 获取国家编码
export const getSelectorNoAuth = (params: Params) =>
	request({
		url: baseUrl + '/sys/sysType/sysTypeSelectorNoAuth',
		method: 'get',
		params: params,
		meta: {
			isToken: false
		}
	})

// 邮箱发送验证码
export const getEmilCode = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/member/email/verificationCode',
		method: 'get',
		params: params
	})
// 生成验证码
export const verificationCode = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/member/verificationCode',
		method: 'post',
		data: params
	})
// 登录
export const loginSave = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/member/login',
		method: 'post',
		data: params
	})
// 注册
export const registerSave = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/member/register',
		method: 'post',
		data: params
	})
// 发送重置密码的邮箱验证码
export const fetForgetCode = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/member/password/reset/verificationCode',
		method: 'post',
		data: params
	})
// 重置密码
export const resetPwd = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/member/password/reset',
		method: 'post',
		data: params
	})
// 根据Id获取用户详情
export const getMemberInfo = (params: Params) =>
	request({
		url: baseUrl + `/marking/api/member/${params.id}`,
		method: 'get',
		params: params
	})

// 收货地址列表
export const getAddressList = (params: Params) =>
	request({
		url: baseUrl + `/marking/api/member/address/list`,
		method: 'get',
		params: params
	})

// 修改会员信息
export const updatauserInfo = (params: Params) =>
	request({
		url: baseUrl + `/marking/api/member/`,
		method: 'put',
		data: params
	})

// 新增收货地址
export const addAddress = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/member/address/',
		method: 'post',
		data: params
	})

// 修改收货地址
export const updateAddress = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/member/address/',
		method: 'put',
		data: params
	})
// 删除收货地址
export const deleteAddress = (params: Params) =>
	request({
		url: baseUrl + `/marking/api/member/address/${params.id}`,
		method: 'delete',
		data: params
	})
// 设置收货地址
export const setDefaultAddress = (params: Params) =>
	request({
		url: baseUrl + `/marking/api/member/address/default/${params.id}`,
		method: 'put',
		data: params
	})
